export default "__VITE_ASSET__e42f1fbd__"